import React, { useContext, useEffect, useRef, useState } from "react";
import styles from "./Counter.module.scss";
import PathContext from "../../context/path";
const Counter = (props) => {
  const { start, finish, duration, floor, manual, triggered } = props;
  const path = useContext(PathContext);
  const refWrap = useRef(null);
  const [isCounting, setCouinting] = useState(false);
  const [currentValue, setCurrentValue] = useState(0);

  useEffect(() => {

    let options = {
      threshold: 1.0,
      rootMargin: '0% 0% -10% 0%'
    }
    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          animateValue(start, finish, duration);
          observer.unobserve(refWrap.current);
        }
      })
    }, options);
    if(manual === undefined || !manual){
      observer.observe(refWrap.current);
    }

    function animateValue(start, end, duration) {
      
      // console.log(isCounting);
      if (!isCounting) {
        setCouinting(true);
        let startTimestamp = null;
        const step = (timestamp) => {
          if (!startTimestamp) startTimestamp = timestamp;
          const progress = Math.min((timestamp - startTimestamp) / duration, 1);
          // setCurrentValue(Math.floor(progress * (end - start) + start));
          setCurrentValue( progress * (end - start) + start);
          if (progress < 1) {
            window.requestAnimationFrame(step);
          }
        };
        window.requestAnimationFrame(step);
      }
    }
    if(manual && triggered){
      animateValue(start, finish, duration);
    }
    
  }, [finish, start, duration, isCounting, manual, triggered]);
  let value = currentValue.toFixed(1).replace(/\./g, ',');
  if(floor !== undefined && floor){
    value = Math.floor(currentValue);
  }
  return (
    <>
      <div className={styles.wrap} ref={refWrap}>
        {value}
        {/* {currentValue} */}
      </div>
    </>
  );

}

export default Counter;
